import {
  ContentLibraryMultiplePageOpenedFile,
  ContentLibraryOpenedFile,
} from 'features/content-library/types';

export const isMultiPageFile = (
  file: ContentLibraryOpenedFile | null
): file is ContentLibraryMultiplePageOpenedFile => !!file && 'pages' in file;
